import React from "react";

import "./fullPageLoader.scss";

export default function FullPageLoader() {
  return <div className="loading">Loading&#8230;</div>;
}
